import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Grid, InputLabel, Paper, TextField, Typography, useMediaQuery } from "@mui/material"
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { usePostEtapaMutation } from "shared/features/api/etapa/etapaSlice";
import { EtapaForm } from "shared/interfaces";
import { newEtapa } from "shared/schemas/newEtapa";

export const AddEtapaForm: React.FC = () => {

    const[criarEtapa] = usePostEtapaMutation();
    const isBelow1705 = useMediaQuery("(max-width:1705px)");


    const onSubmit = async (payloadEtapa: EtapaForm) => {
        await toast.promise(
            criarEtapa(payloadEtapa).unwrap(),
            {
                pending: "Carregando...",
                success: `Etapa criada com sucesso!`,
                error: {
                    render({ data }) {
                    const response = data as {
                        data?: {
                        errors?: string[];
                        message?: string;
                        };
                    };

                    const errorMessage =
                        response.data?.errors?.[0] ||
                        response.data?.message ||
                        `Erro ao criar etapa.`;
                    return errorMessage;
                    },
                },
            }
        )
    }

    const {
        register, 
        handleSubmit,
        formState: {errors},
    } = useForm<EtapaForm>({
        resolver: yupResolver(newEtapa),
    })

    return (
        <Grid
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
            borderRadius: "5px",
            gap: 2,
        }}
        md={12}
        lg={isBelow1705 ? 12: 4.43}
        >
            <Paper sx={{ padding: "16px", height: "100%" }}>
                <Typography fontSize={20} fontWeight={600} mb={2}>
                    Adicionar Etapa
                </Typography>
            
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <InputLabel htmlFor="addEdition-nome">Nome da Etapa*</InputLabel>
                        <TextField
                            fullWidth
                            id="addEtapa-nome"
                            placeholder="Prova"
                            error={!!errors.nome}
                            helperText={errors.nome?.message}
                            {...register("nome")}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button type="submit" variant="contained" fullWidth>
                            Adicionar
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    )
}